<template>
    <SliderRow
        :id="id"
        :label="$t(fieldConfig.label)"
        :value.sync="fieldValue"
        @update:value="syncChange"
    >
        <div slot="label">
            <span>{{ $t(fieldConfig.label) }}</span>
            <ElPopover
                placement="right"
                trigger="hover"
                :visible-arrow="false"
                popper-class="bio-search-setting__popover"
            >
                <AlignmentExplanation
                    v-if="!isNW"
                    :img-src="store.safeImagesUrl('similarityExplanation')"
                />
                <template v-else>
                    <div class="popover-explain">
                        <img
                            class="popover-explain__img mb-3"
                            :src="store.safeImagesUrl('globalAlignmentSimilarityExplanation')"
                        >
                        <div class="popover-explain--row">
                            <span class="mr-1">
                                {{ $t('Search.labels.alignmentIdentity') }}=
                            </span>
                            <span class="popover-explain__vertical">
                                <span class="px-1">
                                    {{ $t('Search.explanation.identityLength') }}
                                </span>
                                <span class="popover-explain__vertica--line" />
                                <span class="px-1">
                                    {{ $t('Search.explanation.alignLength') }}
                                </span>
                            </span>
                            <span class="mx-2"> = </span>
                            <span class="popover-explain__vertical">
                                <span class="px-1">4</span>
                                <span class="popover-explain__vertica--line" />
                                <span class="px-1">8</span>
                            </span>
                        </div>
                    </div>
                </template>
                <PtIcon
                    slot="reference"
                    icon="SolidInfo"
                />
            </ElPopover>
        </div>
    </SliderRow>
</template>

<script>
import Popover from 'element-ui/lib/popover';
import PtIcon from '@patsnap-biz/icon';
import AlignmentExplanation from '../explanations/AlignmentExplanation.vue';
import QueryIdentityField from './QueryIdentity.field.vue';
import { MODIFICATION_SEARCH_ALGORITHM_TYPES } from '../constants';

export default {
    components: {
        AlignmentExplanation,
        PtIcon,
        ElPopover: Popover,
    },
    extends: QueryIdentityField,
    props: {
        fieldName: {
            type: String,
            default: 'perc_identity',
        },
    },
    computed: {
        isNW() {
            return this.store.algorithmType === MODIFICATION_SEARCH_ALGORITHM_TYPES.NW;
        },
    },
};
</script>
